



























import Vue from 'vue';
export default Vue.extend({
  name: 'LoadingSpinner',
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    textColourVariant: {
      type: String,
      required: false,
      default: 'gray'
    },
    cssPositioning: {
      type: String,
      required: false,
      default: 'absolute'
    },
    loadingMessage: {
      type: String,
      required: false,
      default: 'Loading'
    },
    isSpinner: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  created() {
    this.$on('update:loadingSpinnerIsLoading', function(this: any, value: boolean) {
      this.loading = value;
    });
  },
  computed: {
    loading: {
      get(this: any) {
        return this.isLoading;
      },
      set(this: any, value: boolean) {
        this.$emit('update:isLoading', value);
      }
    }
  }
});
